export const siteConfig = {
  name: 'FoodSply',
  description: 'Connect directly to farmers, no middlemen, markups, or stale chains. Buy fresh, fuel locals, build a greener future.',
  url: 'https://foodsply.com',
  ogImage: 'https://foodsply.com/og.jpg',
  links: {
    twitter: 'https://x.com/Lord_Foodsply',
    github: 'https://github.com/foodsply',
    telegram: 'https://t.me/FoodsplyIsOpen_Grpup',
    instagram: 'https://www.instagram.com/lord_foodsply/',
    tiktok: 'https://www.tiktok.com/@foodsply',
  },
};

export const tokenConfig = {
  name: 'FSPY',
  symbol: 'FSPY',
  totalSupply: '1.5',
  blockchain: 'Flare',
  consensus: 'Proof of Stake',
  roles: ['Buy Direct', 'Buy food fractionally', 'Record Keeping', 'Track & Trace Real World Food Assets']
};

export const tokenDistribution = [
  {
    name: 'DeFi & Rewards',
    value: 30,
    color: '#EF9C00',
    description: 'Liquidity pools, staking rewards, and DeFi incentives'
  },
  {
    name: 'Foodsply Reserve',
    value: 25,
    color: '#04AD2F',
    description: 'Strategic reserve for ecosystem development'
  },
  {
    name: 'Operation & Accelerator',
    value: 20,
    color: '#22C55E',
    description: 'Operational expenses and startup acceleration'
  },
  {
    name: 'Team',
    value: 15,
    color: '#3B82F6',
    description: 'Team allocation with vesting schedule'
  },
  {
    name: 'Miscellaneous & Emergency fund',
    value: 9,
    color: '#6366F1',
    description: 'Emergency fund and miscellaneous expenses'
  },
  {
    name: 'Food Distribution & Donation',
    value: 1,
    color: '#8B5CF6',
    description: 'Community food distribution and charitable donations'
  }
];

export const navItems = [
  {
    title: 'Home',
    href: '/',
    isRoute: true,
  },
  {
    title: 'About',
    href: '/about',
    isRoute: true,
  },
  {
    title: 'Tokenomics',
    href: '/#tokenomics',
  },
  // {
  //   title: 'Whitepaper',
  //   href: '/#whitepaper',
  // },
  {
    title: 'NFT',
    href: '/#nft',
  },
  {
    title: 'Team',
    href: '/#team',
  },
  // {
  //   title: 'Join Waitlist',
  //   href: '/waitlist',
  //   isRoute: true,
  // },
];

export const features = [
  {
    title: 'Mint Digital Assets',
    description: 'Create verifiable NFTs representing farm produce, ownership certificates, and agricultural assets for complete traceability.',
    icon: 'M',
  },
  {
    title: 'Trade Food',
    description: 'Connect directly with farmers and trade fresh produce using blockchain technology for transparent, fair pricing.',
    icon: 'T',
  },
  {
    title: 'Track & Trace',
    description: 'Follow your food\'s complete journey with immutable blockchain records from seed planting to final delivery.',
    icon: 'S',
  },
  {
    title: 'Gamified Assets',
    description: 'Experience dynamic food assets with real-time market pricing, seasonal variations, and perishability mechanics that mirror real-world agriculture.',
    icon: 'G',
  },
];